const routes = [
  {
    path: '/debug',
    name: 'debug-mode',
    component: () => import('../views/DebugView.vue'),
  },
];

export default routes;
